exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ed1f1064] .el-tabs__header{margin-bottom:0}[data-v-ed1f1064] .el-button+.el-button.e-btn{margin-left:0}[data-v-ed1f1064] .el-button-group .el-button--primary:first-child{border-right-color:#b3d8ff}[data-v-ed1f1064] .el-button-group>.el-button:not(:last-child){margin-right:0}", ""]);

// exports
